import styled from "styled-components";

export const DetailedTable = styled.table`
  width: 100%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  border: 1px solid #BEAAD1;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  background: white;

  & tr:nth-child(odd) {
    /* background-color: #edf2ff; */
    background-color: #fffbff;
  }

  & th,
  & td {
    padding: 12px 0 12px 16px;
    text-align: left;
  }

  & th:first-child {
    border-top-left-radius: 10px;
  }

  & th:last-child {
    border-top-right-radius: 10px;
  }

  & tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }

  & tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
  & td:nth-child(2) {
    border-left: 1px solid #BEAAD1;
  }
`;
export const DetailedRow = styled.td`
  padding: 14px 20px !important;
`;

export const ClaimsDetailedRow = styled.td`
  padding-top: 20px !important;;
  padding-bottom: 20px !important;;
  padding-left: 101px !important;;
`;
